import { FC } from 'react';

import type { CardProps } from '@/features/selectionsPanel/constants';
import {
  FeatureType,
  type IParcelFeature,
  type ISavedFeature,
} from '@/models/features';

import { ParcelCard } from './parcelCard';

export const SavedCard: FC<CardProps<ISavedFeature>> = ({ feature, idx }) => {
  const parcelFeature: IParcelFeature = {
    geometry: feature.geometry,
    id: feature.id,
    properties: {
      acres: feature.parcel_data?.acres,
      clip: feature.parcel_data?.clip,
      type: FeatureType.SAVED,
    } as unknown as IParcelFeature['properties'],
    type: 'Feature',
  };

  return <ParcelCard feature={parcelFeature} idx={idx} />;
};
